(function ($, window) {
	$(function () {
		const urlParams = new URLSearchParams(window.location.search);
		let isKiosk = false;
		let oldMode = false;

		// set a cookie for a day to not restart the video.

		// Check for kiosk mode.
		if (Cookies.get("kiosk") === "true" || urlParams.has("kiosk")) {
			if (!Cookies.get("kiosk")) {
				Cookies.set("kiosk", "true", { expires: 365 });
			}

			isKiosk = true;

			// Add kiosk-mode class to html.
			$('html').hasClass('kiosk-mode') ? false : $('html').addClass('kiosk-mode');
		}

		// Check for old or new kiosk mode;
		if (Cookies.get("kioskmode") === "old" || urlParams.has('old')) {
			if (!Cookies.get("kioskmode")) {
				Cookies.set("kioskmode", "old", { expires: 365 });
			}

			oldMode = true;
		}

		// Check if home page.
		if ($('body').hasClass('home')) {
			// TODO: Check if popup is already opened or not before opening again it will reset the video.

			// We're using a new Kiosk so open the popup.
			if (isKiosk && !oldMode) {
				const popupWindow = window.open('/video/', 'secondary', 'width=800,height=800');
			}

			// We're using an old Kiosk so fetch request the video to their server.
			if (isKiosk && oldMode) {
				fetch('http://127.0.0.1:8080/play/145087.mp4').catch(function (err) {
					console.log(err);
				});
			}
		}

		// Check if is Kiosk Mode and the thank you page.
		if (isKiosk && $('body').hasClass('page-template-template-thank-you')) {
			// Get the thank you page hero button.
			const heroButton = $('.hero__content .button-group__button--primary');

			// Change it to a start again button.
			heroButton.attr('href', '/');
			heroButton.text('Start again');

			// If no interaction for 2 minutes go back to home page.
			setTimeout(() => {
				window.location = '/';
			}, 120000)
		}
	});
})(jQuery, window);
